import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';

import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button } from 'Components';
import { NotificationManager } from 'Components/Notifications';;

import { useIntl } from "react-intl";

import './style.scss';

import {
    mapSpeedOverrideOpenDeleteModal,
    mapSpeedOverrideDeleteSpeedOverride,
    mapSpeedOverrideClearSearch,
    clearRedux
} from 'Redux/actions';

const SpeedOverrideDelete = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const {
        open,
        speedOverrides,
        response,
        error,
        loading
    } = useSelector(state => state.realtimeMapSpeedOverrideDeleteRedux);

    useEffect(() => {
        if (response && open) {
            NotificationManager.success(
                messages['mapSpeedOverrideDeleteSpeedOverride_success'],
                messages['success'],
                3000,
                null,
                null,
                'success',
            );
            dispatch(mapSpeedOverrideClearSearch())
            dispatch(clearRedux('MAP_SPEED_OVERRIDE_DELETE', { error: false, response: null }));
            handleClose();
        }
    }, [response, open]);

    useEffect(() => {
        if (error && open) {
            NotificationManager.error(
                messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'warning',
            );

            dispatch(clearRedux('MAP_SPEED_OVERRIDE_DELETE', { error: false, response: null }));
        }
    }, [error, open]);


    const handleClose = () => {
        dispatch(mapSpeedOverrideOpenDeleteModal(false, []));
        dispatch(clearRedux('MAP_SPEED_OVERRIDE_DELETE'));
    }

    const deleteSpeedOverride = () => {
        if (open && speedOverrides?.length) {
            const ids = speedOverrides?.map(so => so?.id);
            dispatch(mapSpeedOverrideDeleteSpeedOverride(ids));
        }
    }

    return (
        <Modal
            title={messages['mapSpeedOverrideDeleteSpeedOverride_title']}
            open={open || false}
            position="right"
            className="class-modal-speed-override-delete"
            headerStyle={{
                top: 0
            }}
            loading={loading}
            handleClose={handleClose}
            size="modal-extra-small"
        >
            <ModalBody>
                <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>

                    <div>
                        <p>
                            {messages["mapSpeedOverrideDeleteSpeedOverride_title_detail"]}
                        </p>
                        <p>
                            {messages["mapSpeedOverrideDeleteSpeedOverride_warning"]}
                        </p>
                    </div>

                    <div style={{ padding: 10 }}>
                        <ul>
                            {
                                speedOverrides
                                &&
                                speedOverrides.map((speedOverride, index) => {
                                    return (
                                        <li key={index}>
                                            <span>{speedOverride.name}</span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>

                </div>
            </ModalBody>

            <ModalFooter style={{ bottom: 50 }}>
                <Button
                    disabled={loading}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loading}
                    className="btn-red"
                    onClick={(e) => {
                        e.preventDefault();
                        deleteSpeedOverride();
                    }}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default SpeedOverrideDelete;